export enum FeatureFlagEnum {
  CREATEAUDIENCE ='commerce.segmentations.enableFiltersSegmentationV2',
  GLOBAL_GLOBAL_SHOW_OLD_LOGIN = "global.global.showOldLogin"
}
